import React from "react";
import { Container, Row, Col } from "reactstrap";

const AuthFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="py-5" id="footer-main">
      <Container>
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="6">
            <div className="copyright text-center text-xl-left text-muted">
              © {year} NetCapital
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default AuthFooter;
